import {useIsMobile} from '@sollapay/ui/hooks';

const MOBILE_USER_AGENT_PATTERN = /Android|iPhone|iPad|iPod|Windows Phone|Mobile/i;

export function useIsMobileDevice(): boolean {
  const isMobileViewport = useIsMobile();
  return isMobileViewport && MOBILE_USER_AGENT_PATTERN.test(navigator.userAgent);
}
